var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-duo"},[_c('div',{staticClass:"icon-intile"},[_c('img',{staticClass:"tile-icon-shadow",attrs:{"src":_vm.iconSrc}})]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }